import { createSlice } from '@reduxjs/toolkit';
import type {PayloadAction} from "@reduxjs/toolkit"
import { IServerOptions, IUserSession } from 'common';
import pixyzOperations from 'common/cad/operations/pixyz';
import cadexOperations from 'common/cad/operations/cadex';
import { flattenConfig } from '../../components/revision/revisionEditor/OperationTemplates/commandMap';

type UserState = {
	sessionInfo: IUserSession | null,
	currentOrganization: string,
}

const initialState: UserState = {
	sessionInfo: null,
	currentOrganization: "",
};

const UserSlice = createSlice({
	name: "user",
	initialState: { ...initialState },
	reducers: {
		setUserSessionData(state, action: PayloadAction<IUserSession>)
		{
			if(!action.payload.serverOptions) action.payload.serverOptions = {} as IServerOptions;
			let cadConfiguration;
			if (action.payload.serverOptions?.CAD)
			{
				cadConfiguration = action.payload.serverOptions.CAD.startsWith("pixyz") ? pixyzOperations : cadexOperations;
			}
			action.payload.serverOptions.flattenedConfig = flattenConfig(cadConfiguration) as any; // TODO: Fix this
			state.sessionInfo = { ...action.payload };
		},
		setCurrentOrganization(state, action: PayloadAction<string>)
		{
			state.currentOrganization = action.payload;
		},
	},
});

export default UserSlice;
